import type { Heading } from "../types/content";

const punctuation = /[\s`~!@#$%^&*()+=\[\]{}|\\:;"'<>,.?/，。！？：；“”‘’（）【】《》、·]/g;

export function slugify(value: string) {
  return value
    .trim()
    .toLowerCase()
    .replace(punctuation, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function parseHeadings(markdown: string): Heading[] {
  return markdown
    .split("\n")
    .flatMap((line) => {
      const match = /^(##|###)\s+(.+)$/.exec(line.trim());
      if (!match) return [];
      const text = match[2].replace(/[*_`]/g, "").trim();
      return [
        {
          depth: match[1].length as 2 | 3,
          text,
          id: slugify(text),
        },
      ];
    });
}

export function prepareGuide(markdown: string) {
  return markdown
    .replace(/^# .+\n(?:\n>.*\n?)+/m, "")
    .replace(
      /\[(OS\d{2}|P\d{2})\]/g,
      (_, id: string) => `[${id}](#source-${id.toLowerCase()})`,
    );
}

export function normalizeSearch(value: string) {
  return value.trim().toLocaleLowerCase("zh-CN");
}

export function formatDate(value: string) {
  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(value));
}
